import api from './api';

// Povinná aktualizácia mobilnej appky — hranica verzie pre iOS a Android.
// Endpointy chránené role='admin' (backend appVersion.routes.js).

const getPolicies = () => api.get('/admin/app-versions');

const savePolicy = (platform, minVersion, storeUrl) =>
    api.put(`/admin/app-versions/${platform}`, { minVersion, storeUrl });

const AppVersionService = { getPolicies, savePolicy };

export default AppVersionService;
